import { IconProps } from '../Icons.type'

export function ArrowLeftIcon(props: IconProps) {
  return (
    <svg
      width="25"
      height="25"
      {...props}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_617_7565)">
        <path
          d="M22.8311 12.8306C23.3833 12.8306 23.8311 12.3829 23.8311 11.8306C23.8311 11.2783 23.3833 10.8306 22.8311 10.8306L3.64517 10.8306L7.93806 6.53768C8.32859 6.14715 8.32859 5.51399 7.93806 5.12346C7.54754 4.73294 6.91438 4.73294 6.52385 5.12346L0.523851 11.1235C0.133327 11.514 0.133327 12.1472 0.523851 12.5377L6.52385 18.5377C6.91438 18.9282 7.54754 18.9282 7.93807 18.5377C8.32859 18.1472 8.32859 17.514 7.93807 17.1235L3.64517 12.8306L22.8311 12.8306Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_617_7565">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.0307617 0.0305176)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
